import cx from 'classnames'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'

import { selectPostBoxModal, togglePostBoxModal } from 'store/actions'
import { useDisableScroll } from 'hooks'

import PostBox from '../PostBox'

const PostBoxModal = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const postBoxModal = useSelector(selectPostBoxModal)

  useDisableScroll(postBoxModal?.isActive)

  const onTogglePostBoxModal = () => {
    dispatch(togglePostBoxModal())
  }

  const postBoxTitle = useMemo(() => {
    switch (postBoxModal?.mode) {
      case 'repost':
        return t('post_box_modal.title.repost')
      case 'reply':
        return t('common.reply')
      case 'edit':
        return t('common.edit')
      default:
        return t('common.post')
    }
  }, [postBoxModal])

  return (
    <div
      className={cx('Modal PostBoxModal', {
        'Modal--active': postBoxModal?.isActive,
      })}
    >
      <a
        className="Modal__overlay"
        onClick={() => {
          onTogglePostBoxModal()
        }}
      />

      <div className="Modal__wrapper Modal__wrapper--auto-h">
        <div className="Modal__header Modal__header--bdrz-t">
          <a className="Modal__header__close" onClick={onTogglePostBoxModal} />
          <h2 className="Modal__header__h2">{postBoxTitle}</h2>
        </div>

        <div className="Modal__body">
          <PostBox
            onPostCreated={(createdPostData) => {
              postBoxModal?.onPostCreated?.(createdPostData)
              onTogglePostBoxModal()
            }}
            replyPost={postBoxModal?.post || {}}
            replyPostMode={postBoxModal?.mode}
            groupId={postBoxModal?.post?.group_id ?? postBoxModal?.groupId}
            threadId={postBoxModal?.post?.thread_id ?? postBoxModal?.threadId}
            withinModal
          />
        </div>
      </div>
    </div>
  )
}

export default PostBoxModal
